<!-- statistics-day.vue -->
<template>
  <div class="danmu-page">
    <div class="search-form">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="getList">
        <el-form-item label="查询日期">
          <el-form-item class="begin-item">
            <el-date-picker :editable="false" type="date" placeholder="选择日期" @change="getList" v-model="searchForm.day" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-form-item>
        <!--<el-form-item>
          <el-button type="primary" native-type='submit'>查询</el-button>
        </el-form-item>-->
      </el-form>
    </div>
    <div class="" style="margin-top: 20px">
      <el-row>
        <el-col :span="12">
          <chart class="statistics-chart" :options="chartOption.speakLevelDistr" ref="speakLevelDistr"></chart>
        </el-col>
        <el-col :span="12">
          <chart class="statistics-chart" :options="chartOption.speakBrandDistr" ref="speakBrandDistr"></chart>
        </el-col>
      </el-row>
    </div>
    <div class="" style="margin-top: 20px">
      <h2>每日弹幕发言数排名(前一百)</h2>
      <el-table
        v-loading="loading"
        :data="allData.speakList"
        stripe
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="排名"
          width="100px"
          >
        </el-table-column>
        <el-table-column
          prop="nn"
          label="昵称"
        >
        </el-table-column>
        <el-table-column
          prop="level"
          label="等级"
        >
        </el-table-column>
        <el-table-column
          label="牌子等级"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.brid === '156277'">{{scope.row.bl}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="发言数"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import api from '../api/api'
    export default {
        created() {
          this.getList()
        },
        data() {
            return {
              searchForm: {
                day: moment().subtract(1, "days").startOf('day').format()
              },
              allData: {
                speakLevelDistr: []
              },
              loading: false,
              chartOption: {
                speakLevelDistr: {
                  title : {
                    text: '发言者等级分布（前二十）',
                    left: 'center'
                  },
                  tooltip : {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                  },
                  series : []
                },
                speakBrandDistr: {
                  title : {
                    text: '发言者牌子等级分布（前十）',
                    left: 'center'
                  },
                  tooltip : {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                  },
                  series : []
                }
              }
            }
        },
        components: {},
        watch: {},
        methods: {
          chart() {
            let speakLevelDistrArr = [];
            let speakBrandDistrArr = [];
            if (this.allData.speakLevelDistr) {
              let tmpSpeakLevelDistrArr = []
              tmpSpeakLevelDistrArr = this._.orderBy(this.allData.speakLevelDistr,['count', '_id'], ['desc','asc'])
              // tmpSpeakLevelDistrArr = this._.slice(tmpSpeakLevelDistrArr, 0, 10)
              let otherSpeakLevelCount = 0;
              tmpSpeakLevelDistrArr.forEach(((value, index, array) => {
                if (index < 20) {
                  speakLevelDistrArr.push({value:value.count,name:value._id + '级'})
                }else {
                  otherSpeakLevelCount += value.count
                }
              }));
              speakLevelDistrArr.push({value:otherSpeakLevelCount,name: '其他等级'})
            }
            this.chartOption.speakLevelDistr.series = []
            this.chartOption.speakLevelDistr.series.push({
              name: '等级',
              type: 'pie',
              radius : '70%',
              center: ['50%', '60%'],
              data: speakLevelDistrArr
            })
            if (this.allData.speakBrandDistr) {
              let tmpSpeakBrandDistrArr = []
              tmpSpeakBrandDistrArr = this._.orderBy(this.allData.speakBrandDistr,['count', '_id'], ['desc','asc'])
              // tmpSpeakBrandDistrArr = this._.slice(tmpSpeakBrandDistrArr, 0, 10)
              let otherSpeakBrandCount = 0
              tmpSpeakBrandDistrArr.forEach(((value, index, array) => {
                if (index < 10) {
                  speakBrandDistrArr.push({value:value.count,name:value._id + '级'})
                } else {
                  otherSpeakBrandCount += value.count
                }
              }));
              speakBrandDistrArr.push({value:otherSpeakBrandCount, name: '其他等级'})
            }
            this.chartOption.speakBrandDistr.series = []
            this.chartOption.speakBrandDistr.series.push({
              name: '牌子等级',
              type: 'pie',
              radius : '70%',
              center: ['50%', '60%'],
              data: speakBrandDistrArr
            })
          },
          getList() {
            if (this.searchForm.day) {
              this.loading = true
              api.danmu.statisticsDayList({day:this.searchForm.day}).then(result => {
                if (result.data.code === '0000') {
                  this.allData = result.data.res
                  this.chart()
                  this.loading = false
                } else {
                  this.loading = false
                }
              }).catch(result => {
                console.log(result)
                this.loading = false
              })
            }
          }
        }
    }
</script>
<style></style>



// WEBPACK FOOTER //
// statistics-day.vue?4988c250